import { createFileRoute } from "@tanstack/react-router";
import z from "zod";

import { pageSearchParam } from "@/core/hooks/use-list-search";

export const usageUsersSearchSchema = z.object({
  search: z.string().default("").catch(""),
  status: z
    .enum(["all", "active", "inactive", "suspended"])
    .default("all")
    .catch("all"),
  organization: z.string().default("all").catch("all"),
  domain: z.string().default("all").catch("all"),
  privilege: z
    .enum(["all", "elevated", "standard"])
    .default("all")
    .catch("all"),
  page: pageSearchParam,
});

export const Route = createFileRoute("/_protected/superuser/usage/")({
  validateSearch: usageUsersSearchSchema,
});
